import { api, type QueryParams } from '@/lib/api/client';
import type { AuditEntry, Paginated } from '@/lib/api/types';

/**
 * Audit log client (spec §16 gap 13). Read-only browser over `GET /admin/audit`:
 * paginated, newest first, filtered by entity_type / entity_id / actor_id / action / from / to.
 */
export const auditApi = {
  async list(params?: QueryParams): Promise<Paginated<AuditEntry>> {
    const res = await api.getRaw<AuditEntry[]>('/admin/audit', params);
    return { data: res.data ?? [], meta: res.meta as Paginated<AuditEntry>['meta'] };
  },
};
